import { ValueType } from "@/enums/ValueType";

export function isNumeric(
	valueType?: ValueType,
): valueType is ValueType.Number | ValueType.Currency | ValueType.Percentage {
	if (!valueType) {
		return false;
	}

	switch (valueType) {
		case ValueType.Currency:
		case ValueType.Number:
		case ValueType.Percentage:
			return true;
		case ValueType.Boolean:
		case ValueType.String:
		default:
			return false;
	}
}
